import React from 'react';
import Tools from '../../../Misc/Tools';
import { CoreDebugButtonType } from './core-controlled/debug/core-debug-dropdown-window';
import "./core-general-button2.css"

/*
	EXAMPLE

	<div style={{
				width: '300px',
				height: '100px'
			}} className="center-element">
				<CoreGeneralButton2 type={GeneralButton2Type.one} onClick={() => {
					alert('clicked')
				}} onRenderContent={() => {
					return <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>Some Content</p>
				}} onRenderSecondaryContent={() => {
					return <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>Click Me!!</p>
				}}></CoreGeneralButton2>
			</div> 

*/

const CoreGeneralButton2 = (props: GeneralButton2Config) => {
	return (
		<div className="core-general-button2" tabIndex={0} aria-label={props.ariaLabel} style={{
			width: '100%',
			height: '100%',
			backgroundColor: props.isSelected ? 'gray' : undefined,
			pointerEvents: props.isDisabled ? 'none' : 'all',
			...props.style
		}} onKeyUp={Tools.mapDivEnterToClick} onClick={props.onClick}>
			<button className={"core-general-button2-custom-btn core-general-button2-btn-" + props.type}>
				{props.type === GeneralButton2Type.twelve ? (
					<div>
						<span className='default-text'><div style={{
							position: 'relative',
							top: '50%',
							transform: 'translateY(-50%)'
						}}>{props.onRenderSecondaryContent()}</div></span>
						<span className='default-text'><div style={{
							position: 'relative',
							top: '50%',
							transform: 'translateY(-50%)'
						}}>{props.onRenderContent()}</div></span>
					</div>
				): (
					<span className='default-text'>{props.onRenderContent()}</span>
				)}
				{props.type === GeneralButton2Type.eleven ? (
					<div className="core-general-button2-dot"></div>
				) : (null)}
			</button>
		</div>
	);

};

export interface GeneralButton2Config {
	type: GeneralButton2Type;
	onClick: () => void;
	onRenderContent: () => any;
	onRenderSecondaryContent: () => any;
	ariaLabel?: string;
	style?: any;
	isSelected?: boolean;
	isDisabled?: boolean;
}

export enum GeneralButton2Type {
	one = '1',
	two = '2',
	three = '3',
	four = '4',
	five = '5',
	six = '6',
	seven = '7',
	eight = '8',
	nine = '9',
	ten = '10',
	eleven = '11',
	twelve = '12',
	thirdteen = '13',
	fourteen = '14',
	fifteen = '15',
	sixteen = '16'
}

export default CoreGeneralButton2;
export const AllButton2Types: CoreDebugButtonType<GeneralButton2Type>[] = [
	{
		key: GeneralButton2Type.one,
		value: 'GeneralButton2Type.one'
	},
	{
		key: GeneralButton2Type.two,
		value: 'GeneralButton2Type.two'
	},
	{
		key: GeneralButton2Type.three,
		value: 'GeneralButton2Type.three'
	},
	{
		key: GeneralButton2Type.four,
		value: 'GeneralButton2Type.four'
	},
	{
		key: GeneralButton2Type.five,
		value: 'GeneralButton2Type.five'
	},
	{
		key: GeneralButton2Type.six,
		value: 'GeneralButton2Type.six'
	},
	{
		key: GeneralButton2Type.seven,
		value: 'GeneralButton2Type.seven'
	},
	{
		key: GeneralButton2Type.eight,
		value: 'GeneralButton2Type.eight'
	},
	{
		key: GeneralButton2Type.nine,
		value: 'GeneralButton2Type.nine'
	},
	{
		key: GeneralButton2Type.ten,
		value: 'GeneralButton2Type.ten'
	},
	{
		key: GeneralButton2Type.eleven,
		value: 'GeneralButton2Type.eleven'
	},
	{
		key: GeneralButton2Type.twelve,
		value: 'GeneralButton2Type.twelve'
	},
	{
		key: GeneralButton2Type.thirdteen,
		value: 'GeneralButton2Type.thirdteen'
	},
	{
		key: GeneralButton2Type.fourteen,
		value: 'GeneralButton2Type.fourteen'
	},
	{
		key: GeneralButton2Type.fifteen,
		value: 'GeneralButton2Type.fifteen'
	},
	{
		key: GeneralButton2Type.sixteen,
		value: 'GeneralButton2Type.sixteen'
	}
]
